import "regenerator-runtime/runtime";
import _asyncToGenerator from "F:/openy-admin-all/openy-wxms-web2026-07-24-2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { timeFormat4, timeFormat10 } from '@/utils/index';
import { loadMyActivity } from "@/api/mini";
import { getMySurvey } from "@/api/questionnaire";
export default {
  data: function data() {
    return {
      isShow: false,
      title: '',
      value: '',
      type: '',
      //4、活动 20、表单 
      dataList: [],
      pageNo: 1,
      total: 100,
      pageSize: 20,
      load: true
    };
  },
  methods: {
    // 初始化时间
    initTime: function initTime(val) {
      return !val ? '--' : this.type == 20 ? timeFormat4(val) : timeFormat10(val);
    },
    // 获取参数
    onOpenFn: function onOpenFn(type, name) {
      this.title = name;
      this.type = type;
      this.pageNo = 1;
      this.total = 0; //   this.dataList = [];

      this.load = true;
      this.isShow = true;
      this.getContentList();
    },
    // 查询
    handleClickSearch: function handleClickSearch() {
      this.pageNo = 1;
      this.total = 0;
      this.dataList = [];
      this.load = true;
      this.getContentList();
    },
    // 获取列表数据
    getContentList: function () {
      var _getContentList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.type == 4)) {
                  _context.next = 7;
                  break;
                }

                _context.next = 3;
                return loadMyActivity(this.pageNo, this.value, 1);

              case 3:
                res = _context.sent;
                this.pageSize = 50;
                _context.next = 12;
                break;

              case 7:
                if (!(this.type == 20)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 10;
                return getMySurvey(this.pageNo, this.value, 1);

              case 10:
                res = _context.sent;
                this.pageSize = 20;

              case 12:
                // var res = await fn();
                this.load = false;

                if (!(res.code !== '000000')) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                if (res.datas) {
                  this.dataList = res.datas;
                  this.total = res.pageInfo.rowCount;
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getContentList() {
        return _getContentList.apply(this, arguments);
      }

      return getContentList;
    }(),
    // 分页
    handlChangePage: function handlChangePage(val) {
      this.pageNo = val;
      this.dataList = [];
      this.load = true;
      this.getContentList();
    },
    // 选择数据
    handlClickSelect: function handlClickSelect(item) {
      this.onSelect(item);
    },
    // 关闭弹窗
    onCancel: function onCancel() {
      this.isShow = false;
    }
  }
};